module.exports = __webpack_public_path__ + "static/media/Rectangle 64.9f0c610a.svg";